import { render, staticRenderFns } from "./SingleGridTmpl.vue?vue&type=template&id=b433e9e0&scoped=true&"
import script from "./SingleGridTmpl.vue?vue&type=script&lang=js&"
export * from "./SingleGridTmpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b433e9e0",
  null
  
)

export default component.exports